// extracted by mini-css-extract-plugin
module.exports = {"beforePrice":"styles_beforePrice__8xP9E"};